// Sprachabhängige UI-Texte (Chrome, Labels, Meldungen) — deutsche Fassung.
// Englische Fassung: src/data/en/modules/ui.ts (identische Struktur).
const uiData = {
  languageSwitch: {
    label: "Sprache",
    de: "DE",
    en: "EN",
    switchTo: "Switch to English"
  },
  workDetail: {
    challenge: "Herausforderung",
    solution: "Lösung",
    implementation: "Umsetzung",
    results: "Ergebnisse",
    technologies: "Verwendete Technologien",
    standardLibraries: "Standard-Bausteine",
    codeExamples: "Code-Beispiele",
    backToOverview: "Zurück zur Übersicht",
    gallery: "Einblicke",
    demoVideo: "Im Video",
    project: "Projekt",
    links: "Links",
    date: "Datum",
    platforms: "Plattformen",
    prevCase: "Vorheriges Projekt",
    nextCase: "Nächstes Projekt",
    copyCode: "Code kopieren",
    codeCopied: "Kopiert!",
    learnMoreAbout: "Mehr zu {title} erfahren",
    appStoreDownload: "Im App Store laden",
    showCode: "Code anzeigen",
    example: "Beispiel",
    startProject: "Ein Projekt starten",
    openOnGitHub: "{name} auf GitHub öffnen"
  },
  contact: {
    quickResponseTitle: "Schnelle Antwort gewünscht?",
    quickResponseText: "Nutze das Formular und ich melde mich schnellstmöglich bei Dir zurück.",
    thankYouTitle: "Danke für Dein Interesse",
    successTitle: "Vielen Dank für Deine Nachricht!",
    successText: "Ich werde mich so schnell wie möglich bei Dir melden.",
    sending: "Wird gesendet…",
    errorGeneric: "Beim Senden ist ein Fehler aufgetreten. Bitte versuche es später erneut.",
    errorValidation: "Bitte überprüfe Deine Eingaben und versuche es erneut.",
    newFormButton: "Neues Formular",
    requiredField: "* Pflichtfeld",
    socialTitle: "Finde mich auch auf",
    thankYouText: "Ich freue mich auf spannende neue Projekte und Herausforderungen!"
  },
  notFound: {
    title: "Seite nicht gefunden",
    text: "Die angeforderte Seite existiert nicht oder wurde verschoben.",
    backHome: "Zur Startseite",
    funFact: "Fun Fact: Die erste 404-Fehlermeldung wurde im CERN erfunden, als Forscher den Raum 404 nicht finden konnten. Zum Glück musst Du nicht so weit suchen! 😉"
  },
  nav: {
    menu: "Menü",
    open: "Menü öffnen",
    close: "Menü schließen"
  },
  blog: {
    readMore: "Weiterlesen",
    backToOverview: "Zurück zum Blog",
    readingTime: "{min} Min. Lesezeit"
  },
  comments: {
    title: "Kommentare",
    empty: "Noch keine Kommentare. Mach den Anfang.",
    loginPrompt: "Zum Kommentieren meldest Du Dich kurz an:",
    loginGoogle: "Mit Google anmelden",
    loginApple: "Mit Apple anmelden",
    signedInAs: "Angemeldet als",
    signOut: "Abmelden",
    placeholder: "Was denkst Du darüber?",
    submit: "Kommentar absenden",
    sending: "Wird gesendet…",
    reply: "Antworten",
    cancel: "Abbrechen",
    pendingBadge: "Wartet auf Freigabe",
    pendingNotice: "Danke! Dein Kommentar ist angekommen und wird nach kurzer Prüfung sichtbar.",
    errorGeneric: "Das hat gerade nicht geklappt. Versuch es später noch einmal.",
    errorRateLimited: "Mehr als fünf Kommentare pro Stunde gehen nicht. Kurz durchatmen.",
    errorInvalid: "Der Kommentar ist leer, zu lang oder enthält zu viele Links."
  },
  footer: {
    imprint: "Impressum",
    privacy: "Datenschutz"
  },
  cv: {
    technicalSkills: "Technische Fähigkeiten",
    languages: "Sprachen",
    interests: "Interessen",
    profile: "Profil",
    experience: "Berufserfahrung",
    tasks: "Aufgabenbereiche:",
    clients: "Kunden:",
    emailLabel: "E-Mail",
    phoneLabel: "Telefon",
    addressLabel: "Adresse",
    skillsTech: "Technologien",
    skillsLangs: "Sprachen",
    skillsConcepts: "Konzepte"
  },
  about: {
    badge: "Über mich",
    activityHeatmapAlt: "{name} Aktivitäts-Heatmap",
    activityProfileAria: "{name}-Profil öffnen"
  },
  home: {
    brandGroupAria: "Markengruppe {n}"
  },
  media: {
    previewNotAvailable: "Vorschau nicht verfügbar",
    play: "Video abspielen",
    close: "Schließen",
    deferredLoading: "Später geladen",
    videoUnsupported: "Dein Browser unterstützt das Video-Element nicht."
  },
  dateLocale: "de-DE"
};

export default uiData;
export type UiData = typeof uiData;
